import { createApiCallActions } from '../../../common/store/generic.actions';
import { SalesTeamMember } from './types';

export const salesTeamMemberActions = {
  getById: createApiCallActions<SalesTeamMember>('salesTeamMember', 'getById'),
};

export type SalesTeamMemberAction = typeof salesTeamMemberActions;
